var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:phone-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.556 12.906L16.101 13.359C16.101 13.359 15.018 14.435 12.063 11.497C9.108 8.55898 10.191 7.48298 10.191 7.48298L10.477 7.19698C11.184 6.49498 11.251 5.36698 10.634 4.54298L9.374 2.85998C8.61 1.83998 7.135 1.70498 6.26 2.57498L4.69 4.13498C4.257 4.56698 3.967 5.12498 4.002 5.74498C4.092 7.33198 4.81 10.745 8.814 14.727C13.061 18.949 17.046 19.117 18.675 18.965C19.191 18.917 19.639 18.655 20 18.295L21.42 16.883C22.38 15.93 22.11 14.295 20.882 13.628L18.972 12.589C18.166 12.152 17.186 12.28 16.556 12.906Z",
    fill: "#007D1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8bb31da3bbcdfa14a41ec97d1b360e6f.svg";
export { ForwardRef as ReactComponent };